export const replaceRouteParams = (path, params) => {
  // guard against undefined/non-string paths
  if (typeof path !== 'string' || !path) {
    return '';
  }
  // if no params, return the original path
  if (!params || typeof params !== 'object') {
    return path;
  }

  let newPath = path;
  Object.keys(params).forEach((key) => {
    const regex = new RegExp(`:${key}`, 'g');
    const value = params[key];
    const safeValue = value == null ? '' : String(value);
    newPath = newPath.replace(regex, safeValue);
  });

  return newPath;
};
